export default {
  "footer.events.header": "イベント",
  "footer.events.event.subheader": "イベント一覧",
  "footer.events.event.main": "LINK-J主催・共催",
  "footer.events.event.coSponsorship": "LINK-J協賛・協力",
  "footer.events.event.memberEvent": "特別会員開催",
  "footer.events.event.attend": "出展・参加",
  "footer.events.event.archive": "過去イベント",
  "footer.events.report.subheader": "イベントレポート一覧",
  "footer.events.report.main": "LINK-J主催・共催",
  "footer.events.report.memberEvent": "特別会員開催",
  "footer.events.report.coSponsorship": "LINK-J協賛・協力",
  "footer.events.report.attend": "出展・参加",
  "footer.program.header": "プログラム",
  "footer.program.consultation": "Out of Box相談室",
  "footer.program.program": "アクセラレーションプログラム",
  "footer.program.sandbox": "SANDBOX",
  "footer.program.unikorn": 'What\'s "UNIKORN"？',
  "footer.program.linkBiobay": `What's "LINK-BioBAY TOKYO"？`,
  "footer.interviews.header": "インタビュー・コラム",
  "footer.interviews.interview.subheader": "インタビュー・コラム一覧",
  "footer.interviews.interview.article": "スペシャルインタビュー",
  "footer.interviews.interview.supporter": "会報誌（News Letter）",
  "footer.interviews.interview.column": "日本橋コラム",
  "footer.interviews.interview.staff": "事務局だより",
  "footer.interviews.interview.series": "連載コラム",
  "footer.interviews.interview.startUpInterviews": "ベンチャーインタビュー",
  "footer.interviews.interview.supporterColumn": "サポーターコラム",
  "footer.news.header": "ニュース・掲示板",
  "footer.news.news.subheader": "ニュース一覧",
  "footer.news.news.topics": "トピック",
  "footer.news.news.pressRelease": "プレスリリース",
  "footer.news.news.media": "メディア情報",
  "footer.news.news.overseas": "海外関連",
  "footer.news.news.program": "アクセラレーション",
  "footer.news.news.events": "イベント告知",
  "footer.news.news.sponsorship": "協賛・協力",
  "footer.news.bulletinboard.subheader": "人と情報の交流掲示板一覧",
  "footer.about.header": "LINK-Jを知る",
  "footer.about.greetings": "理事長挨拶",
  "footer.about.why": "Why in Nihonbashi",
  "footer.about.west": "What’s LINK-J WEST",
  "footer.about.overseas": "国内外連携",
  "footer.about.message": "応援メッセージ",
  "footer.about.supporter": "サポーター紹介",
  "footer.about.business.company": "事業内容",
  "footer.about.business.organiation": "組織概要",
  "footer.about.membership.subscription.pamphlet": "パンフレット",
  "footer.about.membership.subscription.gtb": "GTB日本橋エリアについて",
  "footer.membership.header": "特別会員",
  "footer.membership.introduction": "特別会員一覧",
  "footer.membership.existing": "特別会員について",
  "footer.membership.subscription": "入会申し込み",
  "footer.membership.menu": "専用メニューはこちら",
  "footer.facilities.header": "施設・アクセス",
  "footer.facilities.room": "ラウンジ・会議室",
  "footer.facilities.office": "オフィス・ラボ",
  "footer.facilities.access": "アクセス",
  "footer.contact": "お問い合わせ",
  "footer.youtube.link.title": "YouTubeチャンネル",
  "footer.youtube.img.alt": "動画",
  "footer.newsletter": "イベントお知らせメール登録",
  "footer.bbt": "Blockbuster TOKYO",
  "footer.lifeScience.link.title": "ライフサイエンスビルシリーズ",
  "footer.lifeScience.img.alt": "ライフサイエンスビルシリーズ",
  "footer.mitsuiLinkLab.link.title": "三井リンクラボ",
  "footer.mitsuiLinkLab.img.alt": "三井リンクラボ",
  "footer.links.logo":
    "一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン／Life Science Innovation Network Japan",
  "footer.links.list.faq": "よくあるご質問",
  "footer.links.list.help": "このサイトについて",
  "footer.links.list.logoGuidelines": "ロゴガイドライン",
  "footer.links.list.adGuide": "広告掲載について",
  "footer.links.list.tradeLaw": "特定商取引法に基づく表記",
  "footer.links.list.privacy": "個人情報保護に関する基本方針",
  "footer.links.list.use": "個人情報の取扱について",
  "footer.copyright": "© Life Science Innovation Network Japan／",

  "footer.interviews.interview.research": "",
  "footer.links.list.access": "",
  "footer.links.list.termsAndConditions": "",
} as const;
